var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var CircleCheck = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 1024 1024", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M448 706.7a95.71 95.71 0 0 1-67.88-28.07L233.37 531.88a32 32 0 0 1 45.26-45.25l146.74 146.74a32 32 0 0 0 45.26 0l306.74-306.74a32 32 0 0 1 45.26 45.25L515.88 678.63A95.71 95.71 0 0 1 448 706.7z" }),
            React.createElement("path", { className: "cls-1", d: "M512 1024A512.12 512.12 0 0 1 312.7 40.25a512.12 512.12 0 0 1 398.6 943.5A508.73 508.73 0 0 1 512 1024zm0-960a448.13 448.13 0 0 0-174.37 860.81A448.13 448.13 0 0 0 686.37 99.19 445.2 445.2 0 0 0 512 64z" }))))); };
export default CircleCheck;
//# sourceMappingURL=CircleCheck.js.map